var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-name-background-container", style: _vm.containerStyle },
    [
      _c(
        "svg",
        {
          attrs: {
            width: _vm.svgWidth,
            height: _vm.svgHeight,
            viewBox: "0 0 104 47",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c("title", [_vm._v("aiNameBackGround")]),
          _vm._v(" "),
          _c("defs", [
            _c(
              "filter",
              {
                attrs: {
                  x: "-1.5%",
                  y: "-3.5%",
                  width: "103.0%",
                  height: "107.0%",
                  filterUnits: "objectBoundingBox",
                  id: "filter-1"
                }
              },
              [
                _c("feGaussianBlur", {
                  attrs: { stdDeviation: "0.5 0", in: "SourceGraphic" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "filter",
              {
                attrs: {
                  x: "-0.0%",
                  y: "0.0%",
                  width: "100.0%",
                  height: "100.0%",
                  filterUnits: "objectBoundingBox",
                  id: "filter-2"
                }
              },
              [
                _c("feGaussianBlur", {
                  attrs: { stdDeviation: "0 0", in: "SourceGraphic" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                id: "首页",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "首页-ai选题-已生成",
                    fill: _vm.fillColor,
                    "fill-rule": "nonzero"
                  }
                },
                [
                  _c("g", { attrs: { id: "编组-66" } }, [
                    _c("path", {
                      attrs: {
                        d:
                          "M0.98183499,1.1841778 C24.7779858,0.394725932 38.084642,0 40.9018037,0 C43.7189655,0 51.9125671,0 65.4826087,0 L96.6888082,0.835368733 L96.6888082,3.97661121 L97.0846548,4.27861123 L97.0846548,9.24164213 L97.4940038,9.32216042 C97.3784139,13.1892062 97.3784139,15.122729 97.4940038,15.122729 C97.6095937,15.122729 97.9069414,15.122729 98.3860467,15.122729 L98.3860467,22.4764786 L97.8075224,22.4764786 L97.952403,26.1461231 L96.3021004,26.1461231 L96.3021004,26.6315821 L99.3470987,26.6315821 L98.8585565,35.4662072 L99.6249675,35.6203742 L99.8234698,36.7408193 L98.8585565,36.9299127 L98.8585565,37.5170855 L98.3860467,37.8081672 L98.3860467,38.1051509 L65.4826087,38.1051509 L51.421345,38.1051509 L31.7870046,38.1051509 L13.4516329,38.8461007 L32.0350352,39.3450599 L15.2690414,39.3450599 L43.0726992,39.6013549 L98.8585565,40.0076366 C100.055704,40.558871 100.311174,41.0706225 99.6249675,41.5428912 C98.9387612,42.0151599 98.22844,42.1357128 97.4940038,41.90455 L97.0846548,42.7283231 L42.3442469,42.7283231 L0.98183499,42.7283231 C-1.22124533e-14,42.7453722 -0.245458747,42.4707812 0.245458747,41.90455 C0.736376242,41.3383189 1.09317295,41.0044468 1.31584886,40.9029336 L7.56720084,40.9029336 L7.56720084,40.4972675 L0.98183499,40.4972675 L0.98183499,38.3892505 C0.561073249,37.6856064 0.455882814,37.1991604 0.666263684,36.9299127 C0.876644554,36.660665 0.98183499,36.660665 0.98183499,37.1640718 L0.98183499,32.6174 L2.30471062,32.6174 L2.30471062,28.9791768 L0.98183499,28.9791768 L0.98183499,27.4420636 L0.507679379,21.9314831 L2.69501001,21.7957782 C2.43481042,18.8442719 2.30471062,17.3685187 2.30471062,17.3685187 C2.30471062,17.3685187 3.13420161,17.2302955 4.79318359,16.9538492 L7.44240474,16.9538492 L7.30248031,16.488543 L2.69501001,16.488543 L2.69501001,13.7506203 L2.30471062,13.4609312 L2.30471062,7.94077877 L1.39231143,7.94077877 L0.98183499,1.19168623 Z",
                        id: "路径-82备份"
                      }
                    })
                  ])
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-8ab795a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-8ab795a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/ai-name-background/ai-name-background.vue
// module id = null
// module chunks = 